import './ccf-date-picker.module.scss';
import makeStyles from '@mui/styles/makeStyles';
import { CcfTextField } from '../ccf-textfield/ccf-textfield';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

/* eslint-disable-next-line */
export interface CcfDatePickerProps {
  label: string;
}
/**
 * Functional component is a wrapper for material UI card component
 * @param param0 -CcfCardProps
 * @returns material UI card element
 * @example <CcfCard/>
 */
export function CcfDatePicker(props: CcfDatePickerProps) {
  const classes = useStyles();

  return (
    <form className={classes.container} noValidate>
      <CcfTextField
        id="date"
        label={props.label}
        type="date"
        defaultValue=""
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </form>
  );
}

export default CcfDatePicker;
